<template>
    <div class="EstimationsDataEntry">
        <!-- Sales/Profit -->
        <Mikomi_SP :MikomiTypeData="SalesProfitData" :CellTitlePrefix="CellTitlePrefix + ''" :CellColor="CellColor" />
        <!-- Others -->
        <Mikomi_Others :MikomiTypeData="OtherData" :CellTitlePrefix="CellTitlePrefix + ''" :CellColor="CellColor" />
    </div>
</template>

<script>
import Mikomi_SP from './Mikomi_SP.vue';
import Mikomi_Others from './Mikomi_Others.vue';
export default{
    components:{
        Mikomi_SP,
        Mikomi_Others,
    },
    computed:{
        SalesProfitData()
        {
            return {
                // sales: this.MikomiTypeData?.sales ?? 0,
                // provProfit: this.MikomiTypeData?.provProfit,
                sales: this.MikomiTypeData?.sales_figures + this.MikomiTypeData?.sales_plastic + this.MikomiTypeData?.sales_digital + this.MikomiTypeData?.sales_xpna,
                provProfit: this.MikomiTypeData?.provProfit_figures + this.MikomiTypeData?.provProfit_plastic + this.MikomiTypeData?.provProfit_digital + this.MikomiTypeData?.provProfit_xpna,
            };
        },
        OtherData()
        {
            if (this.IsEstimation === false && this.IsResult === false && this.IsDifference === false)
            {
                return {
                    // sales: this.MikomiTypeData?.sales + this.MikomiTypeData?.sales_figures + this.MikomiTypeData?.sales_plastic + this.MikomiTypeData?.sales_digital,
                    sales: this.MikomiTypeData?.sales ?? 0,
                    // In case of result data, the 総益 is named grossOperatingProfit
                    profit: this.MikomiTypeData?.profit,
                    operatingProfit: this.MikomiTypeData?.operatingProfit,
                    netIncome: this.MikomiTypeData?.netIncome,
                    stock: this.MikomiTypeData?.stock
                };  
            }
            else
            {
                return {
                    // sales: this.MikomiTypeData?.sales + this.MikomiTypeData?.sales_figures + this.MikomiTypeData?.sales_plastic + this.MikomiTypeData?.sales_digital,
                    sales: this.MikomiTypeData?.sales ?? 0,
                    // In case of result data, the 総益 is named grossOperatingProfit
                    profit: this.MikomiTypeData?.grossOperatingProfit !== undefined ? this.MikomiTypeData.grossOperatingProfit : null,
                    operatingProfit: this.MikomiTypeData?.operatingProfit,
                    netIncome: this.MikomiTypeData?.netIncome,
                    stock: this.MikomiTypeData?.stock
                };   
            }
        },
    },
    props:{
        MikomiTypeData: Object,
        CellTitlePrefix: String,
        CellColor: String,
        Team: String,
        IsEstimation: Boolean,
        IsResult: Boolean,
        IsDifference: Boolean,
        Month: Number,
    },
    // mounted(){
    //      console.log(`[Mikomi_Type_Other] ${this.Month}月 ${this.Team} ${this.CellTitlePrefix}`, this.MikomiTypeData);
    // }
}
</script>